<script>

  import sgsUtils from './SgsUtils'

  export default{
    props: [
      "attr", "fieldValue", "rules", "label",
      "showHint", "hintValue", "moduleType"
    ],
    data: function () {
      return {
        fileName: ''
      }
    },
    methods: {
      callInputFile: function() {
        document.getElementById('file').click();
      },
      openFile: function(event) {
        var input = event.target;
        var file = input.files[0];

        if(file) {

          //TODO REFATORAR A VALIDAÇÃO DO ARQUIVO, USAR UMA FORMA MAIS INTELIGENTE DE VALIDAR
          //if(file.type === "text/csv") {
          if(file.name.split('.').pop() === "csv") {

            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = () => {
              var text = reader.result;
              this.updateFieldValue = text;
              this.fileName = file.name;
            };

          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Não é possivel fazer o upload de um arquivo que não tenha a extensão ".csv"'
            });
            this.fileName = 'Nenhum arquivo selecionado!';
          }
        }
      }
    },
    computed: {
      updateFieldValue: {
        get: function() {
          return this.fieldValue;
        },
        set: function(newValue) {
          this.$emit('updateFieldValue', this.attr.columnName, newValue);
        }
      }
    },
    created() {
      sgsUtils.resolveRules(this.attr, this.rules);
    }
  }
</script>

<template>
  <div>
    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName" v-if="moduleType === 'form' || attr.type === 'filterText'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <el-button
        type="primary"
        @click="callInputFile()"
        size="small"
        :disabled="attr.disableField"
      >
        {{$t("chooseAFile")}}
      </el-button>
      <input type='file'
             id="file"
             style="display: none;"
             accept=".csv"
             @change='openFile'>
      <br>
      <span>{{fileName}}</span>

    </el-form-item>
    <div v-if="moduleType === 'show'">
      <label>{{label}}</label>
      <p>
        <span>
          <pre>{{updateFieldValue}}</pre>
        </span>
      </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputCsv.vue?61031512